<template>
  <div id="waitDecline">
    <div>
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>不信</b></p>
    <div v-if="isExecuter" class="wait-decline-area">
    <!-- <div v-if="haveDecline" class="wait-decline-area"> -->
      <!-- <div v-if="!sent"> -->
        <p>不信を使用しますか．</p>
        <v-container fluid>
          <v-row justify="center">
            <div class="agree">
              <agreeButton v-if="picked=='true'" label="する" active='true' />
              <agreeButton v-else v-on:pushed="setPick('true')" label="する" active='false' />
            </div>
            <div class="disagree">
              <disagreeButton v-if="picked=='false'" label="しない" active='true' />
              <disagreeButton v-else v-on:pushed="setPick('false')" label="しない" active='false' />
            </div>
          </v-row>
        </v-container>

        <div class="send-button">
          <sendButton v-if="picked" v-on:pushed="push" label="決定" active="true"/>
          <sendButton v-else label="決定" active="false"/>
        </div>

      <!-- </div>
      <div v-else>
        <span>ゲーム情報を取得しています．</span>
      </div> -->
    </div>
    <div v-else>
      <span>{{ executer.name }}が</span><span v-on:click="showEffect(4)" class="plot-name"><b><u>不信</u></b></span>を使用するのを待っています．
    </div>
    </v-card>
    </div>
    <div class="vote-result">
      <v-card
        class="mx-auto"
        max-width="400"
        color="#DDDDFF"
      >
      <p style="color:#444499"><b>投票結果</b></p>
      <div class="vote-table">
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <!-- <tr v-for="prevote in prevotes" :key="prevote.name">
                <td>{{ prevote.name }}</td>
                <td v-if="prevote.vote=='agree'"><span style="color:#222288">承認</span>（総意の形成者）</td>
                <td v-else><span style="color:#C71585">否認</span>（総意の形成者）</td>
              </tr> -->
              <tr v-for="vote in votes" :key="vote.name">
                <td>{{ vote.name }}</td>
                <td v-if="vote.vote=='agree'"><span style="color:#222288">承認</span></td>
                <td v-else><span style="color:#C71585">否認</span></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>
    </div>
  </div>
</template>
<script>
import agreeButton from '@/components/gameUiComponents/AgreeButton.vue'
import disagreeButton from '@/components/gameUiComponents/DisagreeButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "waitDecline",
  plops: [],
  components: {
    agreeButton,
    disagreeButton,
    sendButton
  },
  data() {
    return {
      picked: '',
      socket: this.$store.state.webSocket.socket,
      roomId: this.$store.getters.roomId,
      userName: this.$store.getters.userName,
      userId: this.$store.getters.userId,
      prevotes: this.$store.getters.prevotes,
      votes: this.$store.state.missionInfo.currentVotes,
      sent: false,
    };
  },
  computed: {
    users: function() {
      return this.$store.state.userList.users;
    },
    haveDecline() {
      for (var i in this.users){
        if (this.users[i].id == this.userId){
          const plotCards = this.users[i].plots.filter(plot => plot.id == 4 && !plot.done)
          if (plotCards.length > 0){
            return true
          }
        }
      }
      return false
    },
    executerIndex (){
      return this.$store.state.plotData.plotExecuterIndex
    },
    executer () {
      var leaderIndex = 0;
      for (var i=0; i<this.users.length; i++){
        if(this.users[i].isLeader){
          leaderIndex = i;
          break
        }
      }
      var executer = []
      for (i=0; i<this.users.length; i++){
        // カードごとに実行者をpush
        // for (var j=0; j<this.users[(leaderIndex+i)%this.users.length].plots.filter(plot => plot.id == 4 && !plot.done).length; j++){
        //   executer.push(this.users[(leaderIndex+i)%this.users.length])
        // }

        if(this.users[(leaderIndex+i)%this.users.length].plots.find(plot => plot.id == 4 && !plot.done)){
          console.log(this.users[(leaderIndex+i)%this.users.length])
          executer.push(this.users[(leaderIndex+i)%this.users.length])
        }
      }
      console.log("executer_length: " + executer.length)
      console.log("executer_decline_index: " + this.executerIndex)
      console.log("executer: " + executer[this.executerIndex])
      console.log("executer.length > this.executerIndex+1: " + executer.length > this.executerIndex )
      executer.length > this.executerIndex ? console.log("正") : console.log("誤");

      return executer.length > this.executerIndex ? executer[this.executerIndex] : null
    },
    isExecuter() {
      console.log(this.executer)
      return (this.executer.id == this.userId)
    }
  },
  methods: {
    setPick(pick) {
      this.picked = pick
    },
    push(){
      // var picked = false
      // if (this.picked == 'pick'){
      //   picked = true
      // }
      // this.sent = true
      this.$emit("send-request", {"action": "decide-decline", "roomId": this.roomId, "userId": this.userId, data: {"decline": this.picked}})
      this.picked = ''
    },
    showEffect: function(id){
      var plot = this.$store.getters.getPlotEffect(id);
      console.log(plot)
      var modalContent = {title: plot.name, text: plot.effect}
      this.$emit('send-modal', modalContent)
    }
  },
  created (){
    this.$store.commit('initExecuterIndex')
    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}
      // "wait-spotlight" or "running-mission"
      console.log(res.state)
      var snackText = ""
      if (res.state != "wait-decline"){

        if (res.data.decline == "true"){
          snackText += self.$store.getters.getUserById(res.data.holder).name
          snackText += "により不信が使用されました．"
          self.$store.commit('deletePlot', {'userId': res.data.holder, 'plotId': 4})
        }else {
          snackText = self.executer.name
          snackText += "は不信を使用しませんでした．"
        }
        self.$emit("show-text", {state: "decide-decline", text: snackText})

        var nextState = "waitStrongLeader"
        if (res.state == "wait-strong-leader"){
          nextState = "waitStrongLeader"
        }else if (res.state == "assigning-mission"){
          snackText = "リーダーが"
          snackText += self.$store.getters.getUserById(res.data['next-leader']).name
          snackText += "に移ります．"
          self.$emit("show-text", {state: "decide-decline-next-leader", text: snackText})
          self.$store.commit('setLeader', {userId: res.data['next-leader']})
          if (self.userId == res.data['next-leader']){
            self.$store.commit('beLeader')
          }else {
            self.$store.commit('beMember')
          }
          nextState = "assigningMission"
        }else if (res.state == "wait-spotlight"){
          nextState = "waitSpotlight"
        }else if (res.state == "running-mission"){
          nextState = "runningMission"
        }else if (res.state == "game-finish"){
          snackText = "信任投票が5回否決されたため，スパイの勝利となります．"
          self.$emit("show-text", {state: "decide-decline-game-finish", text: snackText})
          nextState = "result"
        }

        self.$emit("proceed-state", nextState)
      }
      else {
        self.sent = true
        snackText = self.executer.name
        snackText += "は不信を使用しませんでした．"
        self.$emit("show-text", {state: "decide-decline"+self.executer.name, text: snackText})
        self.$store.commit('proceedExecuterIndex')
      }
    }
  }
}
</script>
<style>
#waitDecline .send-button {
  padding-top: 12px;
  padding-bottom: 12px;
}
#waitDecline .agree {
  margin-right: 12px
}

#waitDecline .vote-table{
  align-items: center;
  flex-direction: column;
  display: inline-block;
  text-align:center;
  min-width: 200px
}
#waitDecline .vote-result{
  margin-top: 12px;
}
#waitDecline .plot-name {
  color: #5555BB;
  cursor:pointer;
}
</style>
